import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
// import { createLogger } from 'redux-logger';
import { createBrowserHistory } from 'history';
import combinedReducers from './reducers';
import { routerMiddleware } from 'react-router-redux';

const history = createBrowserHistory();

const appliedMiddleware = applyMiddleware(
    thunk,
    // createLogger(),
    routerMiddleware(history)
);

export default createStore(combinedReducers, appliedMiddleware);



// WEBPACK FOOTER //
// ./src/store.js